import { motion, AnimatePresence } from "framer-motion";
import { FaTimes } from "react-icons/fa";
import logo1 from "../Assets/img/phantom.svg";
import logo3 from "../Assets/logo3.png";
import Rainbow from "../Assets/wall52.webp";
import Coinbase from "../Assets/logo4.png";
import MetaMask from "../Assets/wall7.webp";

const wallets = [
  { name: "Rainbow", logo: Rainbow },
  { name: "Coinbase Wallet", logo: Coinbase },
  { name: "MetaMask", logo: MetaMask },
  { name: "Phantom", logo: logo1 },
  { name: "WalletConnect", logo: logo3, alt: true },
];

export default function ConnectWalletModal({
  isOpen,
  onClose,
  setShowModal2,
  setShowModal3,
}) {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            className="relative flex flex-col md:flex-row w-full max-w-[720px] bg-[#1A1B1F] text-white rounded-[24px] overflow-hidden shadow-2xl border border-white/5"
          >
            {/* Close Button */}
            <button
              className="absolute z-10 p-2 text-gray-400 transition-colors rounded-full bg-white/5 top-4 right-4 hover:bg-white/10 hover:text-white"
              onClick={onClose}
            >
              <FaTimes size={14} />
            </button>

            {/* LEFT COLUMN: Wallet Selection */}
            <div className="w-full md:w-[45%] p-6 border-b md:border-b-0 md:border-r border-white/10">
              <h2 className="mb-6 text-lg font-bold">Connect a Wallet</h2>

              <div className="space-y-1">
                <p className="mb-3 text-xs font-semibold tracking-wider text-gray-500 uppercase">
                  Popular
                </p>
                <div className="flex flex-col gap-1 overflow-y-auto max-h-[300px] md:max-h-[400px] pr-1 custom-scrollbar">
                  {wallets.map((wallet, i) => (
                    <button
                      key={i}
                      onClick={() => {
                        onClose();
                        wallet?.alt ? setShowModal3(true) : setShowModal2(true);
                      }}
                      className="flex items-center w-full gap-4 p-2 transition-all rounded-xl hover:bg-white/5 group"
                    >
                      <img
                        src={wallet.logo}
                        alt={wallet.name}
                        className="w-10 h-10 rounded-full object-contain bg-[#25292E] p-1.5"
                      />
                      <span className="text-[15px] font-semibold text-gray-300 group-hover:text-white">
                        {wallet.name}
                      </span>
                    </button>
                  ))}
                </div>
              </div>
            </div>

            {/* RIGHT COLUMN: Info (Hidden on small mobile if screen is too short, or stacked) */}
            <div className="hidden md:flex flex-col items-center justify-center w-full md:w-[55%] p-10 text-center bg-[#1A1B1F]">
              <h2 className="mb-8 text-xl font-bold">What is a Wallet?</h2>

              <div className="space-y-8 text-left">
                <div className="flex gap-4">
                  <div className="flex items-center justify-center flex-shrink-0 w-12 h-12 border rounded-xl bg-gradient-to-br from-purple-500/20 to-blue-500/20 border-white/10">
                    <span className="text-xl">📦</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-[15px]">
                      A Home for your Digital Assets
                    </h3>
                    <p className="text-sm leading-relaxed text-gray-400">
                      Wallets are used to send, receive, store, and display
                      digital assets like Ethereum and NFTs.
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex items-center justify-center flex-shrink-0 w-12 h-12 border rounded-xl bg-gradient-to-br from-pink-500/20 to-orange-500/20 border-white/10">
                    <span className="text-xl">🔑</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-[15px]">
                      A New Way to Log In
                    </h3>
                    <p className="text-sm leading-relaxed text-gray-400">
                      Instead of creating new accounts and passwords on every
                      website, just connect your wallet.
                    </p>
                  </div>
                </div>
              </div>

              <div className="w-full px-8 mt-12 space-y-4">
                <button className="w-full py-3 font-bold text-white transition-colors bg-blue-600 rounded-full hover:bg-blue-500">
                  Get a Wallet
                </button>
                <button className="block w-full text-sm font-semibold text-blue-400 transition-colors hover:text-blue-300">
                  Learn More
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}
